<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-lg-12">
                    <h3>Upload Identity Documents</h3>
                </div>
                <div class="col-lg-8">
                    <div class="row form-options">
                        <div class="col-lg-6">
                            <identity-type
                                :data-segment-id="dataSegmentId"
                                :disabled="false"
                            ></identity-type>
                        </div>
                        <div class="col-lg-6">
                            <cropper ref="cropper" :field="fieldIdentity">
                            </cropper>
                        </div>
                        <div class="col-lg-6">
                            <cropper-back
                                ref="cropperBack"
                                :field="fieldCNICBack"
                            ></cropper-back>
                        </div>
                        <div class="col-lg-6"></div>
                        <b-button
                            type="button"
                            variant="primary"
                            class="primary-add-btn mr-3"
                            @click="onSave"
                            >SAVE
                        </b-button>
                        <div class="col-lg-6">
                            <base-button
                                btn-type="submit"
                                btn-variant="primary"
                                btn-label="CONTINUE"
                                :class="loading ? 'disabled' : ''"
                                :disabled="loading"
                            ></base-button>
                        </div>

                        <!-- <div class="col-lg-6">
                        <signature ref="signature"></signature>
                    </div> -->
                    </div>
                </div>
                <div class="col-lg-4"></div>
            </div>
        </b-form>
        <b-modal
            ref="requireddocument"
            size="lg"
            title="Required Documents"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <required-documents-popup></required-documents-popup>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'

import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import Cropper from '@/components/registration/Cropper.vue'
import CropperBack from '@/components/registration/CropperBack.vue'
import RequiredDocumentsPopup from '@/components/registration/RequiredDocumentsPopup.vue'
// import Signature from '@/components/registration/Signature.vue'
import resource from '@/api/resource'
const viewBrandingApi = new resource('configurations/branding')
import JSZip from 'jszip'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IdentityType,
        // IdentityDocument,
        UtilityBill,
        Cropper,
        RequiredDocumentsPopup,
        CropperBack,
        // Signature,
        // Disclaimer,
        // VueCroppie,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fieldCNICBack: {
                isRequired: true,
                isLocked: true,
                key: 'documentInfo.cnicBack.fileName',
                originalFileNameKey: 'documentInfo.cnicBack.originalFileName',
                //     keyBackEnd: 'cnicBack',
                // label: 'Id Document BACK SCAN COPY',
                // vvName: 'Id Document BACK scan copy',
                // hyperLink:
                //     'https://www.alfalahghp.com/storage/downloads/K1e4GZMMeZC7zm3Y.pdf',
                // hyperLinkLabel: 'Download sample',
            },

            fieldIdentity: {
                isRequired: true,
                isLocked: true,
                key: 'documentInfo.identity.fileName',
                originalFileNameKey: 'documentInfo.identity.originalFileName',
                keyBackEnd: 'identity',
                //     label: 'Id Document Front SCAN COPY',
                //      vvName: 'Id Document Front scan copy',
                hyperLink:
                    'https://www.alfalahghp.com/storage/downloads/K1e4GZMMeZC7zm3Y.pdf',
                hyperLinkLabel: 'Download sample',
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },

        // isIdle() {
        //     console.log("idle-state: "+this.$store.state.idleVue.isIdle)
        //     return this.$store.state.idleVue.isIdle;
        // },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        async 'this.$store.state.idleVue.isIdle'(value) {
            // console.log('Idel-state:' + value)
        },
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value) {
            // check if the value is not empty
            // and perform action accordintly
            // if (this.userOcr && value !== null && value !== undefined) {
            try {
                const formData = new FormData()
                formData.append(
                    'filePath',
                    `${process.env.VUE_APP_API_URL}files/customers/${value}`
                )
                formData.append('type', 'id')

                const headers = {
                    'Content-Type': 'multipart/form-data',
                }
                const { data } = await request.post('ocr/', formData, {
                    headers,
                })

                debugger
                if (
                    [
                        'identity-document',
                        'upload-document',
                        'record-video',
                        'public-registration-identity-document',
                    ].includes(this.$route.name.toString())
                ) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: data.customer_data.idnumber.replace(/-/g, ''),
                    })

                    this.$store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value: this.$moment(
                            data.customer_data.dateofexpiry,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dateofexpiry,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    this.$store.commit('updateField', {
                        key: 'identityInfo.IssuanceDate',
                        value: this.$moment(
                            data.customer_data.dateofissue,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dateofissue,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    let fullName = _.split(data.customer_data.name, ' ')

                    let firstName = fullName.shift()
                    let lastName = fullName.pop()
                    let middleName = fullName.join(' ')

                    this.$store.commit('updateField', {
                        key: 'basicInfo.firstName',
                        value: firstName + ' ' + middleName + ' ' + lastName,
                    })

                    this.$store.commit('updateField', {
                        key: 'basicInfo.middleName',
                        value: ' ',
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.lastName',
                        value: ' ',
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.dateOfBirth',
                        value: this.$moment(
                            data.customer_data.dob,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dob,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    this.$store.commit('updateField', {
                        key: 'basicInfo.fatherOrHusbandName',
                        value: data.customer_data.fathername,
                    })
                }
            } catch (error) {
                // console.log(error)
            }
            this.$store.commit('setLoading', false)
            // }
        }, // End of user() method
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getBrandingData()
        // this.$refs.requireddocument.show()
        // console.log("idle-state: "+this.$store.state.idleVue.isIdle)
        // this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        // download_btn() {
        //     var new_zip = new JSZip();
        //     var image = ['http://idenfo.test/api/files/customers/file-1624879040996.jpg','http://idenfo.test/api/files/customers/file-1624638060108.jpg']
        //     var img = new_zip.folder('images')
        //     for (let i = 0; i < image.length; i++) {
        //         img.file('img.png', image[i])
        //     }
        //     new_zip.generateAsync({
        //         type: 'blob',
        //     }).then(function (content) {
        //         saveAs(content, 'img_archive_idenfo.zip')
        //     })
        // },
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // this.download_btn()
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                // this.$store.commit('setLoading', true)

                this.$store.commit('updateField', {
                    key: 'forms.form1.valid',
                    value: true,
                })

                // console.log(
                //     'Form 1 is valid ? ' +
                //         this.$store.getters.getField('forms.form1.valid')
                // )

                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        // name: 'public-registration-record-video',
                        name: 'public-registration-setup-profile',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    // this.$router.push('/register-customer/record-video')
                    // this.$router.push('/register-customer/upload-document')
                    this.$router.push({
                        name: 'edit-setup-profile',
                    })
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form1.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        async onSave() {
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'forms.form7.valid',
                    value: true,
                })

                // let invalidForm = false
                // let check = this.checkIsInvalid()
                let registrationUrl = '/customers/update-individual-customer'
                this.$store.commit('setLoading', true)

                try {
                    const formData = this.$store.state.registration.form
                    // formData.dataSegmentId = this.dataSegmentId

                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })

                    this.$toasted.show('Changes saved successfully', {
                        duration: 3000,
                        type: ['success'],
                    })

                    this.$store.commit('setLoading', false)
                } catch (errors) {
                    this.$store.commit('setError', errors)
                    this.$store.commit('setLoading', false)
                }
                // if (!check) {
                // } else {
                //     let msg =
                //         'Kindly fill ' + this.invalidFormNames[0] + ' Form'

                //     this.$store.commit('setError', msg)
                // }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form7.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
